import React, { useEffect } from "react";
import { Flex, Collapse, Form, Input, Select, theme } from "antd";

import { isOibValid } from "../../../../utils/validationUtil.js";
import "./InvestorAdministrationForm.css";
import {axiosInstance} from "../../../../api/axiosInstance.js";
import { cities } from "../../../../constants/constants.js";
import {CaretRightOutlined, PlusOutlined} from "@ant-design/icons";

const InvestorAdministrationForm = ({
  form,
  mode,
  initialValues,
  onFinish,
  disabled,
  activeKey,
  setActiveKey
}) => {
  const { token } = theme.useToken();

  const handleSetActiveKey = (selectedKey) => {
    let activeKeyCopy = [...activeKey];
    const keyAlreadyExists = activeKeyCopy.includes(selectedKey);
    if (keyAlreadyExists) {
        const index = activeKeyCopy.indexOf(selectedKey);
        if (index > -1) {
            activeKeyCopy.splice(index, 1);
        }
    } else {
        activeKeyCopy.push(selectedKey);
    }
    setActiveKey(activeKeyCopy);
};

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues]);

  useEffect(() => {
    if(mode === 'insert'){
      form.resetFields();
    }
  }, [mode]);


  const validateOIB = (rule, value, callback) => {
    if (isOibValid(value)) {
     /* if (mode !== "edit") {
        axiosInstance
          .get(`/api/v1/investors/check-oib-exists/${value}`)
          .then((res) => {
            if (res.data) {
              callback("Već postoji investitor sa istim OIB-om!");
            } else {
              callback();
            }
          });
      } else {
        callback();
      }*/
        callback();
    } else {
      callback("Neispravan OIB");
    }
  };

  const {Panel} = Collapse;
  
  const panelStyle = {
      marginBottom: 0,
      borderRadius: token.borderRadiusLG,
      border: "none",
  };

  return (
    <Form
      form={form}
      name="investorAdministrationForm"
      style={formStyle}
      onFinish={(values) =>
        onFinish({
          ...values,
          id: initialValues?.id,
          address: { ...values.address, id: initialValues?.address?.id },
        })
      }
      initialValues={initialValues}
      layout={"vertical"}
      disabled={disabled}
    >
      <Collapse
          bordered={false}
          expandIcon={({isActive}) => (
              <CaretRightOutlined
                  rotate={isActive ? 90 : 0}
                  style={{
                      background: token.colorBgContainer,
                  }}
              />
          )}
          style={{marginTop: "4px"}}
          activeKey={activeKey}
          ghost
      >
        <Panel
            forceRender={true}
            key="1"
            header="Opći podaci"
            style={{...panelStyle}}
            onClick={(e) => {
                handleSetActiveKey("1");
            }}
        >
            <div onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}>
              <Form.Item
                name={`name`}
                label={`Naziv:`}
                rules={[
                  {
                    required: true,
                    message: "Naziv je obavezno polje!",
                  },
                ]}
              >
                <Input placeholder="Naziv investitora" />
              </Form.Item>
              <Form.Item
                hasFeedback={true}
                name={`oib`}
                label={`OIB:`}
                rules={[
                  {
                    required: true,
                    message: "OIB je obavezno polje!",
                  },
                  {
                    validator: (rule, value, callback) =>
                      validateOIB(rule, value, callback),
                  },
                ]}
              >
                <Input placeholder="OIB investitora" maxLength={11} />
              </Form.Item>
              <Form.Item
                name={["address", "street"]}
                label={`Ulica:`}
                rules={[
                  {
                    required: false,
                    message: "Ulica je obavezno polje!",
                  },
                ]}
              >
                <Input placeholder="Ulica investitora" />
              </Form.Item>
              <Form.Item
                name={["address", "houseNumber"]}
                label={`Kućni broj:`}
                rules={[
                  {
                    required: false,
                    message: "Kućni broj je obavezno polje!",
                  },
                ]}
              >
                <Input placeholder="Kućni broj investitora" />
              </Form.Item>
              <Form.Item
                name={["address", "postNumber"]}
                label={`Poštanski broj:`}
                rules={[
                  {
                    required: false,
                    message: "Poštanski broj je obavezno polje!",
                  },
                ]}
              >
                <Input placeholder="Poštanski broj investitora" />
              </Form.Item>
              <Form.Item
                name={["address", "city"]}
                label={`Grad:`}
                rules={[
                  {
                    required: false,
                    message: "Grad je obavezno polje!",
                  },
                ]}
              >
                <Select
                  options={cities}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                ></Select>
              </Form.Item>
              <Form.Item
                name={`phoneNumber`}
                label={`Broj telefona:`}
                rules={[
                  {
                    required: false,
                    message: "Broje telefona je obavezno polje!",
                  },
                ]}
              >
                <Input placeholder="Broj telefona investitora" />
              </Form.Item>
              <Form.Item
                name={`email`}
                label={`E-mail:`}
                rules={[
                  {
                    required: false,
                    message: "E-mail adresa je obavezno polje!",
                  },
                  {
                    type: "email",
                    message: "E-mail adresa je neispravna!",
                  },
                ]}
              >
                <Input placeholder="E-mail adresa investitora" />
              </Form.Item>
            </div>
          </Panel>
          <Panel
              forceRender={true}
              key="2"
              header="Kontakt osoba"
              style={{...panelStyle}}
              onClick={(e) => {
                  handleSetActiveKey("2");
              }}
          >
            <div onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}>
              <Form.Item
                  name={`contactFirstName`}
                  label={`Ime:`}
                  rules={[
                      {
                          required: false,
                          message: "Ime je obavezno polje!",
                      },
                  ]}
              >
                  <Input placeholder="Ime"/>
              </Form.Item>
              <Form.Item
                  name={`contactLastName`}
                  label={`Prezime:`}
                  rules={[
                      {
                          required: false,
                          message: "Prezime je obavezno polje!",
                      }
                  ]}
              >
                  <Input placeholder="Prezime"/>
              </Form.Item>
              <Form.Item
                  name={`contactEmail`}
                  label={`Email:`}
                  rules={[
                      {
                          required: false,
                          message: "Email je obavezno polje!",
                      }
                  ]}
              >
                  <Input placeholder="Email"/>
              </Form.Item>
              <Form.Item
                  name={`contactMob`}
                  label={`Mob:`}
                  rules={[
                      {
                          required: false,
                          message: "Mob je obavezno polje!",
                      }
                  ]}
              >
                  <Input placeholder="Mob"/>
              </Form.Item>
            </div>
          </Panel>
        </Collapse>
    </Form>
  );
};

export default InvestorAdministrationForm;
